// extracted by mini-css-extract-plugin
export var phone = "styles-module__phone___dPZVZ";
export var error = "styles-module__error___p8nol";